<div class="attribute-editor-component">
  <div class="attribute-editor-row">
    <section
      class="layout-ai-section"
      role="region"
      aria-label="Generate layout"
    >
      <textarea
        id="layout-ai-prompt"
        class="layout-ai-prompt"
        rows="4"
        [(ngModel)]="prompt"
        [disabled]="loading"
        [placeholder]="placeholder"
        [attr.aria-label]="placeholder"
      ></textarea>
      <button
        type="button"
        class="layout-ai-generate-button"
        [class.loading]="loading"
        [disabled]="!canGenerate()"
        [attr.aria-busy]="loading"
        (click)="onGenerate()"
      >
        @if (loading) {
          <span class="layout-ai-spinner" aria-hidden="true"></span>
          <span class="tw-sr-only">Generate layout loading</span>
        } @else {
          <span>Generate layout</span>
        }
      </button>

      @if (messageType) {
        <div
          class="layout-ai-message"
          [class.error]="isErrorMessage()"
          aria-live="polite"
        >
          @switch (messageType) {
            @case ('no_credits') {
              <span>You don't have enough credits. </span>
              @if (canAccessCompanySettings()) {
                <a
                  class="layout-ai-message-link"
                  [uiSref]="'apps.settings.company-details'"
                >
                  See my credits.
                </a>
              }
            }
            @case ('default') {
              <span>Layout generation uses credits. </span>
              @if (canAccessCompanySettings()) {
                <a
                  class="layout-ai-message-link"
                  [uiSref]="'apps.settings.company-details'"
                >
                  See my credits.
                </a>
              }
            }
            @case ('error') {
              <span>Something went wrong. Please try again.</span>
            }
          }
        </div>
      }
    </section>
  </div>
</div>
